var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SvgIcon } from '@ha/dsl';
import React from 'react';
var buildIcon = function (name, Svg) {
    var Icon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
        React.createElement(Svg, null))); };
    Icon.displayName = name;
    return Icon;
};
export default buildIcon;
//# sourceMappingURL=builder.js.map